import { PopupPageId } from "../Components/navigationTypes"

export enum fileTabVal {
    DETAILS = "details",
    DOCUMENTS = "docs",
    CLIENTPORTAL = "clientportal",
    NEWHOME = 'newhome',
    EMPTY = "",
    SUMMARY = "summary",
    WORKSPACE = "workspace",
}

export type WritSearchType = {
    date: Date,
}

export type TitleSearchType = {
    date: Date,
}

export enum CONST {
    uninitialized = "uninit"
}

export type IndicatorBadgeType = {
    type: string,
    label: string,
    category: string,
}

export type TitleInsuranceType = {
    insuranceProvider: string,
}

export type MortgageType = {
    Lender: string,
    PSM: string,
    registrationDate: string,
    instrumentNumber: string,
    position: string,
    type: "New" | "VTB" | "Discharge" | "Assumed" | "Remaining" | "Postpone",
}

export type MortgageSummaryType = {
    lender: string,
    type: "New" | "VTB" | "Discharge" | "Assumed" | "Remaining" | "Postpone",
    amount: string,
    ref: string,
    advance: string,
    position?: string,
    index?: string,
}
export type PersonType = {
    Name: string,
    personType: string,
    OtherPartyType?: string,
    address?: string,
}

export type RegistrationType = {
    Name: string,
    label: string,
}

export type FinanceType = {
    adjustment: {
        bdoc: number,
    },
    account: {
        total: number,
    }
    trust: {
        owingFrom: number,
        owingTo: number,
        netSaleProceeds?: number,
        estimatedOwingFrom: number,
        estimatedOwingTo: number,
        balanceSaleProceeds?: number,
    },
    interimAdjustment: {
        interimBDOC: number,
    }
}

export type PurchaserType = {
    Name: string,
    IsPurchaser: string,
    OnTitle: string,
    personType: string,
    AddressForService: string,
    TransfereeNameFull: string,
    Birthday: string,
    Gender: string,
    TransfereeName: string,
    SpouseNotOnTitle?: string,
    SpouseEmailAddress?: string,
}

export type ContractType = {
    closingDate: Date,
    propertyAddress: string,
}

export type VendorType = {
    Name: string,
    IsVendor: string,
    OnTitle: string,
    personType: string,
    TransferorNameFull: string,
    TransferorName: string,
    AddressForService: string,
    Gender: string,
    HSTNumber: string,
    OnAgreementName?: string,
    SpouseNotOnTitle?: string,
    SpouseEmailAddress?: string,
}

export type GuarantorType = {
    Name: string,
}

export type PriorOwnerType = {
    Name: string,
}

export type DepositType = {
    Amount: string,
}

export type PayeeType = {
    name: string;
    displayTitle: string;
    address: string;
}

export type PurchaserSummaryType = {
    name: string;
    mainContact: string;
    verifications: {
        singleProcess: number;
        dualProcess: number;
    };
    phone: string;
    email: string;
}

export type RegistrationSummaryType = {
    desc: string;
    date: string;
    instrumentNo: string;
}

export type TitleInsuranceSummaryType = {
    provider: string;
    status: string;
    amount: string;
    policyNo: string;
}

export type ThirdPartySummaryType = {
    name: string;
    type: string;
    company: string;
    email: string;
    phone: string;
    address: string;
    personType: PopupPageId;
    index?: number;
}

export type MortgageSolicitorType = {
    name: string;
    lender: string;
    email: string;
    phone: string;
    index: number;
}

export type ContactType = {
    name: string;
    phone: string;
    email: string;
}
